import { tryParseBoolean } from '@witkac/utils/tryParseBoolean';

/**
 * Konfiguracja modułów
 *
 * @export
 * @class ModulesConfig
 */
export class ModulesConfig {
  /**
   * Czy ma być włączony moduł punktów
   *
   * @type {boolean}
   * @memberof ModulesConfig
   */
  public points: boolean;

  constructor() {
    this.points = tryParseBoolean(process.env.VUE_APP_MODULE_POINTS, false) as boolean;
  }
}
